module.exports = __webpack_public_path__ + "img/Ecosystem services (ESS-Development dependencies on ESS.39b39e70.svg";